<template>
  <svg
    class="absolute w-12 inset-x-0 top-0 md:-translate-y-1/2 mx-auto pointer-events-none mb-4 md:mb-0"
    width="49"
    height="56"
    viewBox="0 0 49 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3040_3170)">
      <path
        d="M24.3479 56C25.8696 54.4783 29.2783 51.9217 32.5348 50.9478C36.2783 49.8217 45.9261 48.087 48.1783 38.1957C49.9435 30.4348 46.5957 21.7 46.2305 17.7739C45.8957 14.3043 46.9305 6.48261 47.1131 5.29565C47.3566 3.71304 45.8348 3.10435 44.8305 3.46957C43.1566 4.1087 39.5957 5.23478 35.5479 5.29565C31.1348 5.35652 25.7479 2.13043 24.3479 0C22.9783 2.13043 17.5609 5.35652 13.1783 5.26522C9.10003 5.20435 5.53916 4.04783 3.89569 3.43913C2.89134 3.07391 1.40003 3.68261 1.61308 5.26522C1.79569 6.45217 2.83047 14.3043 2.49569 17.7435C2.10003 21.6696 -1.24779 30.3739 0.54786 38.1652C2.80003 48.0565 12.4783 49.7913 16.1913 50.9174C19.4479 51.8913 22.8566 54.4783 24.3783 55.9696"
        fill="#EF3E42"
      />
    </g>
    <defs>
      <clipPath id="clip0_3040_3170">
        <rect width="48.6957" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
